import React, { useState, useEffect } from 'react'
import moment from 'moment';
import { Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import _ from 'lodash'

// component
import AnimationLoading from '../../../components/Animationloading';
import CustomButton from '../../../components/CustomButton';
import { USER_KEY } from '../../../const';
import { errorSwal, successDeleteSwal, successSwal, successUpdateSwal } from '../../../helper/sweetalert';
import PaginationHelper from '../../../components/PaginationHelper';
import ConfirmDelete from '../../../components/ConfirmDelete';
import EmptyComponent from '../../../components/EmptyComponent';

// apollo
import { useLazyQuery, useMutation } from '@apollo/client';
import { GET_BRANDS } from '../../../apollo/brand/Query';
import { GET_SUBBRANDS } from '../../../apollo/subbrand/query';
import { CREATE_SUBBRAND, DELETE_SUBBRAND, UPDATE_SUBBRAND } from '../../../apollo/subbrand/mutation';

// icon
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineBorderColor } from "react-icons/md";

// react bootrap
import { Form, Modal, Spinner, Table, InputGroup } from 'react-bootstrap';
import ComfirmModal from '../../../components/ComfirmModal';

export default function SubBrand() {
    const history = useHistory()
    const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
    const [subBrand, setSubBrand] = useState()
    const [brand, setBrand] = useState()
    const [subBrandTotal, setSubBrandTotal] = useState()
    const [selectBrand, setSelectBrand] = useState()
    const [showDelete, setShowDelete] = useState(false);
    const [Delete, setDelete] = useState("");
    const [selectEditBrand, setSelectEditBrand] = useState()
    const [searchSubBrand, setSearchSubBrand] = useState();
    const [searchBrand, setSearchBrand] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const { _limit, _skip, Pagination_helper } = PaginationHelper();
    const [showBrand, setShowBrand] = useState(false)
    const [isEdit, setIsEdit] = useState(false);
    const [editIndex, setEditIndex] = useState();
    const [editData, setEditData] = useState({});


    // ==========> useLazyQuery And useMutation <==========

    const [loadsubbrand, { data: getsubbrand, loading }] = useLazyQuery(GET_SUBBRANDS, { fetchPolicy: "cache-and-network" });
    const [loadbrand, { data: getbrand, loading: loaddingbrand }] = useLazyQuery(GET_BRANDS, { fetchPolicy: "cache-and-network" });
    const [createsubbrand, { loading: loadingCreate }] = useMutation(CREATE_SUBBRAND)
    const [updatebrand, { loading: loadingUpdate }] = useMutation(UPDATE_SUBBRAND)
    const [deletesubbrand, { loading: loadingDelete }] = useMutation(DELETE_SUBBRAND)

    // ==========> useEffect <==========

    useEffect(() => {
        _filter()
        _fetchBrand()
    }, [])

    useEffect(() => {
        if (getsubbrand) {
            setSubBrand(getsubbrand?.subBrands?.data)
            setSubBrandTotal(getsubbrand?.subBrands?.total)
        }
    }, [getsubbrand]);


    // console.log("subbarnd total==>", subBrandTotal)

    useEffect(() => {
        if (getbrand) {
            setBrand(getbrand?.brands?.data)
        }
    }, [getbrand]);

    useEffect(() => {
        _filter()
    }, [searchSubBrand, searchBrand])

    // <=============== create subBrand =================>

    const _createSubBrand = async (values) => {
        // console.log({ selectBrand })
        // console.log({ values })
        if (!values.name) {
            errorSwal("ກະລຸນາເພີ່ມເເບນ...")
            return
        }
        try {
            if (loadingCreate) return;
            await createsubbrand({
                orderBy: "createdAt_DESC",
                variables: {
                    data: {
                        ...values,
                    },
                }
            })

            _filter()
            successSwal('ເພີ່ມສຳເລັດ')
            setShowBrand(false)
        } catch (err) {
            errorSwal('ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ')
            // console.log('error creating todo:', err)
        }
    }

    // ========== update ExchangeRate ==========
    const _updatebrand = async () => {
        try {
            if (loadingUpdate) return;
            await updatebrand({
                orderBy: "createdAt_DESC",
                variables: {
                    where: {
                        id: editData?.id,
                    },
                    data: {
                        name: editData?.name,
                        brand: selectEditBrand
                    }
                },
            });

            setIsEdit(false);
            setEditIndex();
            setEditData({});
            successUpdateSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
            _filter()
            setSelectEditBrand()
        } catch (err) {
            errorSwal('ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ')
            // console.log("error creating todo:", err);
        }
    };

    // ==========> fuction delete  <==========
    const handleShowDelete = (id, name) => {
        setDelete({ name, id });
        setShowDelete(true);
    };

    const _confirmeDelete = async () => {
        try {
            if (loadingDelete) return;
            await deletesubbrand({
                variables: {
                    where: {
                        id: Delete?.id,
                    },
                },
            });
            _filter()
            successDeleteSwal('ລົບສຳເລັດ')
            setShowDelete(false);
        } catch (err) {
            errorSwal("ການລົບຂໍ້ມູນບໍ່ສຳເລັດ !");
        }
    };

    const _filter = async () => {
        try {
            let shopId = JSON.parse(localStorage.getItem('SHOP_DATA'))?.id

            let _where = {
                shop: shopId,
                isDeleted: false,
            }

            // TODO: check if search text is not empty
            // if (!_.isEmpty(searchCategory)) { _where = { ..._where, title: searchCategory, } }
            if (searchSubBrand !== "") {
                _where = {
                    ..._where,
                    name: searchSubBrand
                }
            }

            if (!_.isEmpty(searchBrand) && searchBrand !== "ALL") {
                // console.log("step 2")
                _where = { ..._where, brand: searchBrand }
            }


            // TODO: Get all product

            await loadsubbrand({
                variables: {
                    skip: (_skip - 1) * _limit,
                    limit: _limit,
                    orderBy: "createdAt_DESC",
                    where: _where
                },
            });


        } catch (error) {
            console.log("Error: ", error)
        }
    }


    const _fetchBrand = async () => {
        await loadbrand({
            variables: {
                limit: 500,
                where: {
                    shop: shopId,
                    isDeleted: false
                },
            },
        });
    }

    const handleChangBrand = (event) => {
        setSelectBrand(event.target.value)
    }

    const handleChangeEditBrand = (event) => {
        setSelectEditBrand(event.target.value)
    }

    // ================ Edit in box ========
    const onEditData = async (data, index) => {
        setIsEdit(true);
        setEditIndex(index);
        setEditData(data);
    };

    const onCancelEditData = async () => {
        setIsEdit(false);
        setEditIndex();
        setEditData({});
    };
    return (
        <React.Fragment>

            <div style={{
                paddingLeft: "15px",
                paddingRight: "15px"
            }}>
                <div style={{
                    backgroundColor: "#FFFFFF",
                    padding: '20px',
                    height: '100vh',
                    overflow: 'auto'

                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        color: "#3C169B"
                    }}>
                        <span style={{ fontSize: '24px', color: '#6B7280' }}>
                            <ArrowBackIcon sx={{ fontSize: "30px", cursor: "pointer" }} onClick={() => history.goBack()} />
                            &emsp;
                            ຕັ້ງຄ່າຊັບເເບນ({subBrandTotal})
                        </span>
                        <span>
                            <CustomButton
                                width="165px"
                                height="46px"
                                title="ເພີ່ມເເບນ"
                                icon={<AddBoxOutlinedIcon />}
                                borderRadius="8px"
                                onClick={() => setShowBrand(true)}
                            />

                        </span>
                    </div>

                    {/* table */}
                    <div style={{ display: "flex" }}>
                        <div style={{ width: "30%" }}>
                            <InputGroup>
                                <InputGroup.Text style={{
                                    backgroundColor: "#FFFFFF",
                                }}>
                                    <SearchIcon sx={{ color: "#6B7280" }} />
                                </InputGroup.Text>
                                <Form.Control
                                    placeholder="ຄົ້ນຫາຊັບເເບນສິນຄ້າ..."
                                    aria-describedby="basic-addon2"
                                    onChange={(e) => {
                                        setSearchSubBrand(e.target.value);
                                    }}
                                    value={searchSubBrand}
                                    style={{
                                        borderLeft: 'none',
                                        // width: '40px',
                                        // maxWidth: '420px'
                                    }}
                                />
                            </InputGroup>
                        </div>
                        <div style={{ width: "20%", marginLeft: "20px" }}>
                            <Form.Select style={{
                                height: '40px',
                                // width: '271px',
                                // minWidth: "271px",
                                color: '#6B7280',
                                cursor: 'pointer'
                            }}
                                onChange={(e) => {
                                    setSearchBrand(e.target.value)
                                }}
                                value={searchBrand}
                            >
                                <option value="ALL">ເເບຣນທັງໝົດ</option>
                                {
                                    brand?.map((brands, index) => (
                                        <option key={brands + index} value={brands?.id}>{brands?.name}</option>
                                    ))
                                }
                            </Form.Select>
                        </div>
                    </div>
                    {(loading && !getsubbrand) && <AnimationLoading />}
                    {
                        subBrand?.length > 0 ? <Table style={{
                            marginTop: "20px",
                            borderCollapse: "collapse",
                            width: "100% ",
                        }}>
                            <thead style={{
                                background: "#1F3A60",
                                borderRadius: " 8px 8px 0px 0px",
                                color: "#FFFFFF"
                            }} >
                                <tr>
                                    <th>ລ/ດ</th>
                                    <th>ຊື່</th>
                                    <th>ເເບນທີ່ລີ້ງ</th>
                                    <th>ວັນທີເດືອນປີ</th>
                                    <th>ຈັດການ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    subBrand?.map((sub, index) => {
                                        return (
                                            <tr key={sub + index} style={{ alignItems: 'center', whiteSpace: 'nowrap' }}>
                                                <td style={{ paddingTop: '1rem' }}>{index + 1 + _limit * (_skip - 1)}</td>
                                                <td style={{ paddingTop: '1rem' }}>
                                                    {isEdit == true && editIndex === index ? (
                                                        <Form.Control
                                                            type="text"
                                                            name="name"
                                                            onChange={(e) => {
                                                                let _data = editData;
                                                                _data = {
                                                                    ...editData,
                                                                    name: e?.target?.value,
                                                                };
                                                                setEditData(_data);
                                                            }}
                                                            value={editData.name}
                                                            placeholder="ຊື່ສິນຄ້າ..."
                                                            style={{
                                                                border: editData.name ? "" : "solid 1px red",
                                                            }}
                                                        />
                                                    ) : (
                                                        <div>
                                                            {sub?.name}
                                                        </div>
                                                    )}
                                                </td>
                                                <td style={{ paddingTop: '1rem' }}>
                                                    {isEdit == true && editIndex === index ? (
                                                        <Form.Select
                                                            value={selectEditBrand}
                                                            onChange={handleChangeEditBrand}
                                                            defaultValue={sub?.brand?.id}
                                                        >
                                                            {
                                                                brand?.map((e, index) => (
                                                                    <option key={index} value={e?.id}>{e?.name}</option>
                                                                ))
                                                            }
                                                        </Form.Select>
                                                    ) : (
                                                        <div>
                                                            {sub?.brand?.name}
                                                        </div>
                                                    )}
                                                </td>
                                                <td style={{ paddingTop: '1rem' }}> {moment(sub?.createdAt).format('DD/MM/YYYY')}</td>

                                                {isEdit == true && editIndex === index ? (
                                                    <td style={{ width: "30%" }}>
                                                        <div style={{ display: "flex" }}>
                                                            <CustomButton
                                                                width="149px"
                                                                height="42px"
                                                                color="#3058A6"
                                                                background="#F1F1F1"
                                                                borderRadius="8px"
                                                                title="ຍົກເລີກ"
                                                                onClick={() => onCancelEditData()}
                                                            />
                                                            &ensp;
                                                            <CustomButton
                                                                width="149px"
                                                                height="42px"
                                                                borderRadius="8px"
                                                                title={loadingUpdate ? <Spinner /> : "ບັນທືກ"}
                                                                onClick={() => _updatebrand()}
                                                            />
                                                        </div>
                                                    </td>
                                                ) : (
                                                    <td style={{ width: "30%" }}>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            <CustomButton
                                                                width="149px"
                                                                height="42px"
                                                                borderRadius="8px"
                                                                textalign="center"
                                                                border="1px solid #3C169B"
                                                                title="ເເກ້ໄຂ"
                                                                color="#3C169B"
                                                                background="#F7F7F7"
                                                                icon={<MdOutlineBorderColor style={{ color: "#3C169B", fontSize: '20px' }} />}
                                                                onClick={() => onEditData(sub, index)}
                                                            />
                                                            &ensp;
                                                            <CustomButton
                                                                width="149px"
                                                                height="42px"
                                                                margin="0"
                                                                title=" ລົບ"
                                                                border="1px solid #DC2626"
                                                                borderRadius="8px"
                                                                background="#F7F7F7"
                                                                color="#DC2626"
                                                                icon={<RiDeleteBin6Line style={{ color: '#D21C1C', fontSize: "20px" }} />}
                                                                onClick={() => handleShowDelete(sub?.id, sub?.name)}
                                                            />
                                                        </div>
                                                    </td>
                                                )}

                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table> : <div>
                            {subBrand?.length <= 0 && <div style={{
                                fontSize: "24px",
                                display: 'flex',
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: 'center',
                                color: "#6B7280",
                                fontWeight: "400"
                            }}>
                                <EmptyComponent />
                                <p>ຍັງບໍ່ມີຊັບເເບຣນກະລຸນາໄປເພີ່ມຊັບເເບຣນກ່ອນ !!!</p>
                            </div>}
                        </div>
                    }


                    {/* {subBrandTotal > 0 ? <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-around",
                                        alignItems: 'center'
                                    }}
                                >
                                    {(subBrandTotal) && <div className="show">ກຳລັງສະແດງ {50 * _skip - 49}-{(50 * _skip) > subBrandTotal ? subBrandTotal : 50 * _skip} ຈາກ {subBrandTotal}</div>}
                                    <div>
                                        {Pagination_helper(subBrandTotal, "", ``)}
                                    </div>
                                    <div></div>
                                    <div />
                                </div> : ""} */}

                    {/* end table */}
                </div>
            </div>


            {/* end delete modal */}

            <ComfirmModal
                showConfirmModal={showDelete}
                handleCancel={() => setShowDelete(false)}
                handleConfirm={
                    _confirmeDelete
                }
                title="ແຈ້ງເຕືອນ"
                text={
                    `ທ່ານຕອ້ງການລົບຂໍ້ມູນ` + ` ${Delete?.name}` + ` ນີ້ເເທ້ບໍ່!`
                }
            />


            {/* create subBrand */}

            <Modal show={showBrand} onHide={() => setShowBrand(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>ເພີ່ມຊັບເເບນ</Modal.Title>
                </Modal.Header>
                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        name: '',
                        shop: shopId,
                        brand: selectBrand

                    }}
                    validate={values => {
                        // const errors = {};
                        // if (!values.name) {
                        //     errors.name = 'ກະລຸນາປ້ອນ ຊື່ເເບນ... !';
                        // }
                        // return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        await _createSubBrand(values)
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                    }) => (
                        <>
                            <Modal.Body>
                                <Form.Label>ເລືອກເຊື່ອມກັບເເບນ</Form.Label>

                                <Form.Select
                                    value={values.brand}
                                    onChange={handleChangBrand}

                                >
                                    <option>ເລືອກເເບນ</option>
                                    {
                                        brand?.map((e, index) => (
                                            <option key={index} value={e?.id}>{e?.name}</option>
                                        ))
                                    }
                                </Form.Select>

                                <Form.Label>ຊື່ຊັບເເບນ</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.name}
                                    placeholder="ຊື່ຊັບເເບນ..."
                                />
                            </Modal.Body>
                            <Modal.Footer>
                                <CustomButton
                                    title="ຍົກເລີກ"
                                    width="100px"
                                    background="#A9B3BD"
                                    borderRadius="8px"
                                    onClick={() => setShowBrand(false)}
                                />
                                &ensp;
                                <CustomButton
                                    title={loadingCreate ? <Spinner /> : "ບັນທຶກ"}
                                    width="100px"
                                    borderRadius="8px"
                                    onClick={() => handleSubmit()}
                                />
                            </Modal.Footer>
                        </>
                    )}
                </Formik>
            </Modal>

        </React.Fragment>
    )
}
